import React from 'react';
import { withStyles } from "@mui/styles";
import UploadPreview from './UploadPreview';
import UploadThumbnail from "./UploadThumbnail";
import ItemTypeIcon from "../../../../../helpers/ItemTypeIcon";
import {API_ROOT} from "../../../../../baseUrls";
import SurveyView from "../../surveys/SurveyView";
import {
  answerAllSurveyShare,
  answerSurveyShare,
  loadSurveyShare,
  resetSurveyShare
} from "../../../../../state/actions/surveyActions";
import {connect} from "react-redux";

const styles = {
  root:{
    display:'flex',
    flexDirection:'column',
    gap: '0.75rem',
    padding:'0.5rem'
  },
  name:{
    fontSize: '1.75em',
    fontWeight:600,
    marginRight: 'auto',
    display:'block',
    wordBreak:'break-all',
    '& > svg':{
      color: '#005985',
      width: '1em',
      height: '1em',
      fontSize: 'inherit',
      margin: '0.2em 0.35em 0 0',
      // alignSelf: 'first baseline',
      verticalAlign: 'text-bottom',
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '1.5rem',
    position:'relative'
  },
  thumbnail:{
    width: '200px',
    height: '200px',
  },
  description:{
    fontWeight: 300,
    flexBasis: '176px',
    flexGrow: 1,
    flexShrink: 0,
  },
  descriptionText: {
    whiteSpace: 'pre-wrap',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'inherit',
    width: '100%',
    boxSizing:'border-box'
  },
  label: {
    fontSize:'0.7225rem',
    fontWeight: 600,
    color: '#888',
    textTransform: 'uppercase',
    lineHeight: '1.35em',
  },
  preview:{
    display:'flex',
    width:'100%',
    justifyContent: 'center',

    textAlign:'center',
    // margin:'0 auto',
  }
};

function PublicItemView(props) {
  const { item, shareHash, loadSurveyShare, classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.row} style={{flexWrap:'wrap-reverse'}}>
        <div className={classes.name}>
          <ItemTypeIcon item={item} />
          {item.name}
        </div>
        <div className={classes.mindfile}>
          Shared from {item.mindfile_name}'s Mindfile
        </div>
      </div>
      <div className={classes.body}>
        <div className={classes.row}>
          {(item.item_data_type === 'Upload' && ((item.item_data.type !== 'image' && item.item_data.type !== 'audio') || !item.item_data.conversion)) ?
            <UploadThumbnail item={item} ignoreConversion={true} size="lg" className={classes.thumbnail}
              thumbnailPath={`${API_ROOT}/view/share/${shareHash}/thumbnail`}
            />
            : null
          }
          <div className={classes.description}>
            <div className={classes.label}>
              Description
            </div>
            <div className={classes.descriptionText}>
              {item.description}
            </div>
          </div>
        </div>
        {item.item_data_type !== 'Upload' || !item.item_data.conversion ? null :
          <div className={classes.preview}>
            <UploadPreview item={item} ignoreConversion={true}
              thumbnailPath={`${API_ROOT}/view/share/${shareHash}/thumbnail`}
              previewPath={`${API_ROOT}/view/share/${shareHash}/preview`}
              mindfileUserLevel={4}
            />
          </div>
        }
        {item.item_data_type !== 'SurveyAttempt' ? null :
          <div className={classes.preview}>
            <SurveyView
              isViewingShared
              attemptId={shareHash}
              surveyAttempt={item.item_data}
              loadSurvey={loadSurveyShare.bind(this, shareHash)}
              // answerSurvey={(answer, callback) => {
              //   answerSurveyShare(shareHash, answer, (surveyAttempt) => {
              //     callback(surveyAttempt);
              //     setItem({...item, item_data: surveyAttempt})
              //   })
              // }}
              // answerAllSurvey={(answer, callback) => {
              //   answerAllSurveyShare(shareHash, answer, (surveyAttempt) => {
              //     callback(surveyAttempt);
              //     setItem({...item, item_data: surveyAttempt})
              //   })
              // }}
            />
          </div>
        }
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
  };
}

const mapDispatchToProps = {
  loadSurveyShare,
  resetSurveyShare,
  answerSurveyShare,
  answerAllSurveyShare,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PublicItemView));
